import * as React from 'react'
import { ThemeProvider } from 'src/theme'
import LogoComponent from 'src/components/LogoComponent'
import * as Styles from '../styles/PreArrivalPage.styles'
import LanguageSwitcher from 'src/components/LanguageSwitcher'
import { Suggest } from 'react-geosuggest';
import { SignupOutcome } from 'src/components/SignupOutcome';
import LoadingIcon from 'src/components/Loading';
// tslint:disable-next-line:no-var-requires
const marked = require('marked')
// tslint:disable:jsx-no-lambda

export interface ITouristContent {
  theme: {
    content: any
  }
  Body: string
  image: string
  search_placeholder: string
  address_search_text: string
  sq_success_text: string
  centre_offers_label: string
  sq_disclaimer: string
  sq_failure_text: string
  centre_offers_url: {
    url: string
  }


}
export interface ITouristProps {
  touristContent?: ITouristContent
  content: {
    conditionsMessage: string
  }
  locale: string
  isLoading: boolean
  addressEntered: boolean
  isLocal: boolean | undefined
  isTourist: boolean | undefined
  disabled: boolean
  handleClick(e: React.MouseEvent<HTMLButtonElement, MouseEvent>): void
  changeLocale(e: React.MouseEvent<HTMLButtonElement, MouseEvent>): void
  handleFailureClick(e: React.MouseEvent<HTMLButtonElement, MouseEvent>): void
  onSuggestSelect(suggest: Suggest): void
  handleSuccessClick(): void
}

export class TouristPage extends React.Component<ITouristProps> {
  public render() {
    const languageContent = {
      ...this.props.content,
      isPreArrival: true
    }
    const { isLoading, touristContent, isLocal, isTourist, disabled, addressEntered } = this.props
    return (
      <ThemeProvider theme={touristContent!.theme.content}>
        <>
          <LogoComponent 
            theme={touristContent!.theme} 
            logo={touristContent!.theme.content.Site_logo[0]} 
            hidePadding={true}
          />
          <Styles.CentreSpan theme={touristContent!.theme} addPadding={isLocal || isTourist}>
            <Styles.CentreLogo src={touristContent!.image}/>
              <Styles.LanguageSelectionText>Select your language</Styles.LanguageSelectionText>
              <LanguageSwitcher
                locale={this.props.locale}
                content={languageContent}
                changeLocale={this.props.changeLocale}
              />
              <Styles.Body theme={touristContent!.theme.content} dangerouslySetInnerHTML={{ __html: marked(touristContent!.Body) }}/>
            { !isLoading && !addressEntered && 
              <Styles.InputForm>
                <Styles.StyledGeoSuggest 
                  placeholder={touristContent!.search_placeholder}
                  onSuggestSelect={this.props.onSuggestSelect}
                  theme={touristContent!.theme}
                />
                <Styles.Disclaimer theme={touristContent!.theme.content}>{touristContent!.sq_disclaimer}</Styles.Disclaimer>
                <Styles.NextButton disabled={disabled} onClick={this.props.handleClick} theme={touristContent!.theme}>
                  {touristContent!.address_search_text}
                </Styles.NextButton>

              </Styles.InputForm>
            }
            { isLoading && <LoadingIcon fixposition={true}/> }
            { isTourist && !isLoading &&
              <SignupOutcome 
                theme={touristContent!.theme}
                content={touristContent!.sq_success_text}
                onClick={this.props.handleSuccessClick} 
                buttonContent={touristContent!.centre_offers_label}
                isFailure={false}
              />
            }
            { isLocal && !isLoading && 
              <SignupOutcome 
                theme={touristContent!.theme}
                content={touristContent!.sq_failure_text}
                onClick={() => window.open(touristContent!.centre_offers_url.url)} 
                buttonContent={touristContent!.centre_offers_label}
                isFailure={true}
                handleFailureClick={this.props.handleFailureClick}
              />
            }
          </Styles.CentreSpan>
          <Styles.ConditionsMessage 
            dangerouslySetInnerHTML={{ __html: this.props.content.conditionsMessage }} 
            addMargin={isTourist || isLocal}
          />
      </>
    </ThemeProvider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/TouristPage.tsx